import React, { useEffect, useState } from 'react';
import styles from '../styles/BackToTop.module.css';

export default function BackToTop() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 420);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });

        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const handleClick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    if (!visible) return null;

    return (
        <button
            type="button"
            className={styles.backToTop}
            onClick={handleClick}
            aria-label="Back to top"
            title="Back to top"
        >
            <span className={styles.icon} aria-hidden="true">↑</span>
        </button>
    );
}
